import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeDeviceTypeComponent } from './change-device-type.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [ChangeDeviceTypeComponent],
  imports: [CommonModule, FormsModule, MatFormFieldModule, ReactiveFormsModule, TranslateModule],
  exports: [ChangeDeviceTypeComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class ChangeDeviceTypeModule {}
